import { BlankSlate } from "@msuite/ui/blank-slate";
import { Button } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import type { Tables } from "@msuite/utils/types";
import { PartnerAgreementCard } from "@/components/cards/partner-agreement-card";

/** Props Interface */
interface NumericAgreementHistoryModalProps extends ModalProps {
	agreements: Array<Tables<"organizationPartnershipAgreements">>;
	onCompleteEdit: () => Promise<void>;
	orgId: string;
	partnershipId: string;
}

export function NumericAgreementHistoryModal({
	isOpen,
	onClose,
	agreements,
	onCompleteEdit,
	orgId,
	partnershipId,
}: NumericAgreementHistoryModalProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t("general.history")}
			width="50rem"
		>
			<Modal.Body>
				{!agreements.length && <BlankSlate />}
				{agreements.map((agreement, index) => (
					<PartnerAgreementCard
						key={agreement.id}
						agreement={agreement}
						followUpAgreement={agreements[index - 1]}
						onCompleteEdit={onCompleteEdit}
						orgId={orgId}
						partnershipId={partnershipId}
						agreements={agreements}
					/>
				))}
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onClose}>{t("general.close")}</Button>
			</Modal.Footer>
		</Modal>
	);
}
